module.exports = __webpack_public_path__ + "static/img/city02.1be14ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city02.jpg
// module id = H3kz
// module chunks = 0